import React from "react";
import Seo from "components/Seo";
import CompanyLayout from "./companyLayout";
import Organization from "../../../common/-pages/company/organization";

const MorningOrganization = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="조직도" />
            <CompanyLayout>
                <Organization />
            </CompanyLayout>
        </React.Fragment>
    );
};

export default MorningOrganization;
